import React, { useEffect } from 'react'

import Connect from 'components/Artefacts/IframeWhiteboard/Connect'
import ConnectToTablet from 'components/Controls/ConnectToTablet/ConnectToTablet'
import WhiteboardModeButton from 'components/Controls/WhiteboardModeButton/WhiteboardModeButton'
import useRoomState from 'hooks/useRoomState/useRoomState'
import useVideoContext from 'hooks/useVideoContext/useVideoContext'
import { _isTeacher } from 'store/selectors/User'

import { ModesContainer, Container } from './styles'

import LeftControlBarTab from '../LeftControlBarTab'

const imgProps = {
    alt: 'whiteboard-icon',
    src: '/assets/revamp/whiteboard.svg',
    height: '80%',
    width: '80%',
}

const Whiteboard = ({ rightControl }) => {
    const { whiteboard } = useVideoContext()
    const {
        popupRef,
        isWhiteboardOpen,
        toggleWhiteboard,
        isDisabled,
        isWhiteboardModesListOpen,
        toggleWhiteboardModesListOpen,
        isConnectToTabletModalOpen,
        toggleConnectToTabletModalOpen,
    } = whiteboard

    const roomState = useRoomState()

    if (rightControl && isWhiteboardOpen) return null

    return (
        <Container rightControl={rightControl}>
            <LeftControlBarTab
                iconProps={imgProps}
                isEnabled={isWhiteboardOpen}
                isDisabled={isDisabled}
                onClick={toggleWhiteboard}
                title={isWhiteboardModesListOpen ? null : 'whiteboard'}
                rightControl={rightControl}
                className="hover-here"
            />
            <Connect
                isConnectToTabletModalOpen={isConnectToTabletModalOpen}
                toggleConnectToTabletModalOpen={toggleConnectToTabletModalOpen}
                isWhiteboardModesListOpen={isWhiteboardModesListOpen}
                toggleWhiteboardModesListOpen={toggleWhiteboardModesListOpen}
            />
            {rightControl &&
                isWhiteboardModesListOpen &&
                roomState !== 'disconnected' && (
                    <ModesContainer ref={popupRef}>
                        <WhiteboardModeButton
                            disabled={isDisabled}
                            togglePopupOpened={toggleWhiteboardModesListOpen}
                        />
                        <ConnectToTablet
                            toggleConnectToTabletModalOpen={
                                toggleConnectToTabletModalOpen
                            }
                            isConnectToTabletModalOpen={
                                isConnectToTabletModalOpen
                            }
                            disabled={isDisabled}
                        ></ConnectToTablet>
                    </ModesContainer>
                )}
        </Container>
    )
}

export default Whiteboard
